import React, { useState, useEffect, memo } from 'react';
import { LoadingSpinner } from '../common/loadingSpinner';
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { apiSlice, useGetLimitedArticlesQuery } from '../redux/api-slice';
import Article from './Article';
import InfiniteScroll from 'react-infinite-scroll-component';
import { setCurrentPage, setPagination } from '../redux/settings/page-settings-slice';


export default function SubCategoryContainer() {
    const dispatch = useAppDispatch();
    const currentFilter = useAppSelector((state) => state.filterState.filters) as any;
    const currentPage = useAppSelector((state) => state.pageSettings.page);
    const limit = useAppSelector((state) => state.pageSettings.limit);
    const pagination = useAppSelector((state) => state.pageSettings.pagination);
    const sortType = useAppSelector((state) => state.pageSettings.sortType);
    const isLandingPage = useAppSelector((state) => state.pageSettings.isLandingPage);
    const { data } = useGetLimitedArticlesQuery({ page: currentPage, limit: limit, filter: currentFilter, landingPage: isLandingPage, sortBy: sortType });
    const noResultsText = useAppSelector((state) => state.pageSettings.noResultsText);

    let fetchMoreData = () => {
        dispatch(setCurrentPage(currentPage + 1))
        if (data.count <= data.items.length) {
            dispatch(setPagination(false))
        }
    }

    useEffect(() => {
        dispatch(setPagination(true))
    }, [sortType]);

    return (
        <>
            {data ?
                <InfiniteScroll
                    dataLength={data.items.length}
                    next={fetchMoreData}
                    hasMore={pagination}
                    scrollThreshold={0.6}
                    loader={<LoadingSpinner />}
                    endMessage={<p className="otc-listing-results-final rich-text space-top-md" dangerouslySetInnerHTML={{ __html: noResultsText }}></p>}
                >
                    <ul className="otc-listing-results">
                        {data.items.map((article, index) => (
                            <Article result={article} id={article.id} key={index} />
                        ))}
                    </ul>

                </InfiniteScroll>
                : <LoadingSpinner />
            }

        </>
    );
}
